import { Link } from 'react-router-dom';
import Navigation from './Navigation';
import iWillLogo from '../../assets/iWillLogo.png';
import Button from 'components/Form/Button';
import LoginModal from 'apps/user/page/authentication';
import { useRef, useState } from 'react';
import { UserInfoDto } from 'service/dto/user.dto';
import useOnClickOutside from 'common/hooks/useOnClickOutside';
import { Icon, Icons } from 'components/Icon';
import Dropdown from 'components/Navigation/Dropdown';
import ImageAvatar from 'components/ImageAvatar';

type Props = {
  user: UserInfoDto | null;
};
const LandingMenuDesktop = ({ user }: Props) => {
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [showDropdown, setShowDropdown] = useState<boolean>(false);
  const rootRef = useRef<HTMLInputElement>(null);

  const close = () => {
    setShowDropdown(false);
  };
  useOnClickOutside(rootRef, close);

  return (
    <div>
      <div className="relative z-50 ml-3 mr-6 hidden h-full items-center tablet:flex 1xl:mx-0">
        <Link className="mr-5 1xl:mr-10" to="/">
          <img src={iWillLogo} alt="iWillLogo" className="h-10 w-32" />
        </Link>
        <div className="flex grow space-x-4 py-5 1xl:space-x-8">
          <Navigation
            navClassName="flex pl-10 1xl:space-x-3 space-x-0 items-center p-2 justify-center"
            iconClassName="hidden 1xl:flex"
          />
        </div>
        <div className="absolute right-0 top-0 h-full">
          <div className="flex h-full items-center gap-10 pl-8 pr-3">
            <span className="text-sm font-bold text-primary-800">
              (01-2499-900)
            </span>
            {!user ? (
              <>
                <span
                  className="text-base font-normal"
                  role="button"
                  tabIndex={-1}
                  onKeyDown={() => setShowLoginModal(true)}
                  onClick={() => setShowLoginModal(true)}
                >
                  Login
                </span>
                <Link to="/get-started">
                  <Button
                    variant="primary"
                    size="md"
                    className="w-[7rem] rounded-xl"
                    label="Get Started"
                  ></Button>
                </Link>
              </>
            ) : (
              <>
                <div
                  role="button"
                  tabIndex={-1}
                  ref={rootRef}
                  className="m-3"
                  onClick={() => setShowDropdown(prevState => !prevState)}
                >
                  <div className="flex items-center gap-3">
                    <ImageAvatar
                      imageUrl={user?.image}
                      className="h-12 w-12 rounded-full"
                    />
                    <span className="text-sm font-bold text-[#353535]">{`${user?.surname} ${user?.othername}`}</span>
                    <Icon name={Icons.ArrowDown} />
                  </div>
                  {showDropdown && (
                    <div className="flex justify-end">
                      <div className="absolute z-50 m-2 w-56 list-none divide-y divide-gray-100 rounded-lg bg-white text-base shadow">
                        <Dropdown close={close} isRoot={true} />
                      </div>
                    </div>
                  )}
                </div>
              </>
            )}
          </div>
        </div>
      </div>
      {showLoginModal && <LoginModal onDismiss={setShowLoginModal} />}
    </div>
  );
};

export default LandingMenuDesktop;
